<template>
  <el-dialog
    :title="$t('chooseinitializeCommunity.warmPrompt')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog">
    <div class="modal-body">
      <p style="color: red;">
        {{ $t('chooseinitializeCommunity.operateCarefully') }}，{{ $t('chooseinitializeCommunity.warningMessage', {communityName: chooseinitializeCommunityInfo.communityName, communityId: chooseinitializeCommunityInfo.communityId}) }}
      </p>
      <br>
      <el-input
        v-model="chooseinitializeCommunityInfo._devPassword"
        :placeholder="$t('chooseinitializeCommunity.inputDevPassword')"
        class="form-control-sm">
      </el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('chooseinitializeCommunity.wrongClick') }}
      </el-button>
      <el-button type="primary" @click="authenticationDevPassword">
        {{ $t('chooseinitializeCommunity.confirmFormat') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ChooseInitializeCommunity',
  data() {
    return {
      dialogVisible: false,
      chooseinitializeCommunityInfo: {
        communityName: '',
        communityId: '',
        _devPassword: ''
      }
    }
  },
  methods: {
    open(initializeCommunity) {
      this.chooseinitializeCommunityInfo.communityName = initializeCommunity.name
      this.chooseinitializeCommunityInfo.communityId = initializeCommunity.communityId
      this.dialogVisible = true
      this._refreshChooseinitializeCommunityInfo()
    },
    authenticationDevPassword() {
      this.$emit('chooseinitializeCommunity', this.chooseinitializeCommunityInfo)
      this.dialogVisible = false
    },
    _refreshChooseinitializeCommunityInfo() {
      this.chooseinitializeCommunityInfo._devPassword = ""
    },
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.form-control-sm {
  width: 100%;
}
</style>